import React, { Dispatch, SetStateAction } from "react";
import { Outlet, useOutletContext } from "react-router-dom";

import { UseOutletContextInventory } from "../Inventory"; // Asumiendo que aún usas el contexto de inventario base
import { AppService } from "../../../../models/app.service.model";
import { Company } from "../../../../models/company.model";
import { Brand } from "../../../../models/brands.inventory.model"; // Nuevo modelo Brand
import { AccountingAccount } from "../../../../models/accounting.account.model";

export interface BrandPageProps {}

type ContexType = {
  setRoute: Dispatch<SetStateAction<{ path: { root: string; branch: string } | null; company: boolean } | null>>;
  appServiceForUser: AppService | null;
  companyForUser: Company | null;
  brandsForCompany: Brand[] | null;
  accountingExpenseAccountsForCompany: AccountingAccount[] | null;
  accountingVatAccountsForCompany: AccountingAccount[] | null;
  accountingIncomeAccountsForCompany: AccountingAccount[] | null;
  setBrandsForCompany: Dispatch<SetStateAction<Brand[] | null>>;
  loadServicesForCompany: Function;
  loadProductsForCompany: Function;
};

const BrandPage: React.FunctionComponent<BrandPageProps> = (props) => {
  const {
    setRoute,
    appServiceForUser,
    companyForUser,
    brandsForCompany,
    accountingExpenseAccountsForCompany,
    accountingVatAccountsForCompany,
    accountingIncomeAccountsForCompany,
    loadServicesForCompany,
    loadProductsForCompany,
  } = UseOutletContextInventory();

  return (
    <Outlet
      context={{
        setRoute,
        appServiceForUser,
        companyForUser,
        brandsForCompany,
        accountingExpenseAccountsForCompany,
        accountingVatAccountsForCompany,
        accountingIncomeAccountsForCompany,
        loadServicesForCompany,
        loadProductsForCompany,
      }}
    />
  );
};

export function UseOutletContextBrand() {
  return useOutletContext<ContexType>();
}

export default BrandPage;
